import { styles } from "./dlq-styles";

export function DlqField({
  label,
  htmlFor,
  children,
}: {
  label: string;
  htmlFor: string;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <div style={styles.field}>
      <label htmlFor={htmlFor} style={styles.label}>
        {label}
      </label>
      {children}
    </div>
  );
}
